var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBird1 = function SvgBird1(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29,
    height: 49
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1e2022",
    d: "M12.37 49H11v-3.89l-2.626.473-.246-1.339L11 43.727v-6.98H0L5.5 31.3V0l16.492 4.083 6.873-1.361-6.873 8.166v25.86h-5.5v7.373l-4.124.742V49Zm0-12.249v6.729l2.75-.495v-6.238ZM16.494 6.8a1.361 1.361 0 1 0 1.374 1.361A1.37 1.37 0 0 0 16.494 6.8"
  })));
};
export default SvgBird1;